import script from "./TintBoltBrand.vue?vue&type=script&setup=true&lang=js"
export * from "./TintBoltBrand.vue?vue&type=script&setup=true&lang=js"

import "./TintBoltBrand.vue?vue&type=style&index=0&id=2bb4a435&scoped=true&lang=css"
import "./TintBoltBrand.vue?vue&type=style&index=1&id=2bb4a435&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb4a435"]])

export default __exports__